import React from "react";
import {Status} from "../../common/Constants";

export const formGroup = {
    serviceId: {value: null},
    kodeJasa: {value: null, mandatory: true},
    namaJasa: {value: null, mandatory: true},
    frt: {value: null, mandatory: true},
    serviceCategory: {value: null, mandatory: true},
    kodeVarian: {value: null, mandatory: true},
    namaVarian: {value: null, mandatory: true},
    status: {value: Status.ACTIVE},
};

export const defaultFilter = {
    kodeJasa: null,
    namaJasa: null,
    serviceCategory: null,
    kodeVarian: null,
    namaVarian: null,
};

export const tableConfig = (pagination) => [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (value, tableMeta) => {
              const rowNumber =
                (pagination.page - 1) * pagination.limit + tableMeta.rowIndex + 1;
                    
              return rowNumber;
            },
        },
    },
    {name: "kodeJasa", label: "Kode Jasa/Job", options: {sort: false}},
    {name: "namaJasa", label: "Nama Jasa", options: {sort: false}},
    {name: "serviceCategory", label: "Service Category", options: {sort: false}},
    {name: "kodeVarian", label: "Kode Varian", options: {sort: false}},
    {name: "namaVarian", label: "Nama Varian", options: {sort: false}},
];